import { Component, OnInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private _document: Document,
    ) { }

  ngOnInit() {
    this.titleService.setTitle('AI英文校正ツールTrinkaの機能');
    this.metaTagService.updateTag({ name: 'description', content: 'AI英文校正ツールTrinka（トリンカ）は、英語論文の校正・テクニカルライティングの英文チェックに最適。英語のトーンやスタイルを出版レベルへと洗練するTrinkaの機能をご紹介。' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'テクニカルライティング,アカデミックライティング,英文チェッカー,校正ツール,AI校正ツール,AIツール,学術論文,文法チェック,文法チェックツール,英文　校正　サイト,英文校正　無料,英文チェック　サイト,スタイルガイド,スペルチェック,構文チェック,Trinka,トリンカ' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'AI英文校正ツールTrinkaの機能' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'AI英文校正ツールTrinka（トリンカ）は、英語論文の校正・テクニカルライティングの英文チェックに最適。英語のトーンやスタイルを出版レベルへと洗練するTrinkaの機能をご紹介。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'AI英文校正ツールTrinkaの機能' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "AI英文校正ツールTrinka（トリンカ）は、英語論文の校正・テクニカルライティングの英文チェックに最適。英語のトーンやスタイルを出版レベルへと洗練するTrinkaの機能をご紹介。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features' });
    

    if (isPlatformServer(this.platformId)) {
      const script = this._renderer2.createElement('script');
      script.type = 'application/ld+json';
      script.text = `{"@context":"https://schema.org/","@type":"WebPage","@id":"#WebPage","url":"https://www.trinka.ai/jp/features","name":"AI英文校正ツールTrinkaの機能"}`
      this._renderer2.appendChild(this._document.head, script);
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
